import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MerchantUserModel } from "../models/merchantUser";
import { RoleModel } from "../models/role";

interface RoleInterface {
  data: RoleModel[] | null;
}

const initialState: RoleInterface = {
  data: null,
};

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    addRole: (state: RoleInterface, action: PayloadAction<RoleModel[]>) => {
      state.data = action.payload;
    },
  },
});

export const { addRole } = roleSlice.actions;
export default roleSlice.reducer;
